import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgClearIcon = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", id: "clear-icon_svg_plugin_20238", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Group 2536" }, /* @__PURE__ */ React.createElement("g", { id: "Union" }, /* @__PURE__ */ React.createElement("path", { d: "M10 2.88594C10 2.99639 9.91046 3.08594 9.8 3.08594H6.2C6.08954 3.08594 6 2.99639 6 2.88594V2.03594C6 1.92548 6.08954 1.83594 6.2 1.83594H9.8C9.91046 1.83594 10 1.92548 10 2.03594V2.88594ZM3.375 5.13599H2.2C2.08954 5.13599 2 5.04644 2 4.93599V4.08599C2 3.97553 2.08954 3.88599 2.2 3.88599H13.8C13.9105 3.88599 14 3.97553 14 4.08599V4.93599C14 5.04644 13.9105 5.13599 13.8 5.13599H12.625V13.6641C12.625 13.9402 12.4011 14.1641 12.125 14.1641H3.875C3.59886 14.1641 3.375 13.9402 3.375 13.6641V5.13599ZM4.625 5.13599V12.9141H11.375V5.13599H4.625ZM7.175 7.11108C7.28546 7.11108 7.375 7.20063 7.375 7.31108V10.9111C7.375 11.0215 7.28546 11.1111 7.175 11.1111H6.325C6.21454 11.1111 6.125 11.0215 6.125 10.9111V7.31108C6.125 7.20063 6.21454 7.11108 6.325 7.11108H7.175ZM9.675 11.1111C9.78546 11.1111 9.875 11.0215 9.875 10.9111V7.31108C9.875 7.20063 9.78546 7.11108 9.675 7.11108H8.825C8.71454 7.11108 8.625 7.20063 8.625 7.31108V10.9111C8.625 11.0215 8.71454 11.1111 8.825 11.1111H9.675Z", fill: "#127FFF" }))));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgClearIcon;
